export const formatTime = dateStr => {
  const date = dateStr && new Date(dateStr);
  return date ? date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }) : '';
};
